export function updateOrderedProductPricelistItem(order, nextOrderedItem) {
  const nextOrderedItems = order.ordered_product_pricelist_items
    .map(orderedItem => {
      if (orderedItem.product_pricelist_item.id == nextOrderedItem.product_pricelist_item.id) {
        return nextOrderedItem
      } else {
        return orderedItem
      }
    })

  return {
    ...order,
    ordered_product_pricelist_items: nextOrderedItems
  }
}

export function updateOrderedProductOrderField(order, parent, { product_order_field }, value) {
  if (parent.model_name === "Order") {
    parent = order
  } else if (parent.model_name === "OrderedProductPricelistItem") {
    parent = order.ordered_product_pricelist_items
      .find(orderedItem => orderedItem.product_pricelist_item.id === parent.product_pricelist_item.id)
    if (!parent) { return order }
  } else if (parent.model_name === "OrderCustomerParticipant") {
    parent = order.order_customer_participants
      .find(participant => participant.position === parent.position)
    if (!parent) { return order }
  } else {
    throw "Unknown parent.model_name"
  }

  const previousOrderedField = parent.ordered_product_order_fields
    .find(orderedField => orderedField.product_order_field.id === product_order_field.id)
  if (!previousOrderedField) { return order }
  const nextOrderedField = {
    ...previousOrderedField,
    value,
  }

  // If participants data aren't touched,
  // and if first participant's full name is the same as customer's,
  // then set his name to the same one as well
  // Do the same for all common customer/participant props
  Array.prototype.forEach.call(["full_name", "email", "phone_number", "birth_date"], prop => {
    if (!order._participantsCustomerFieldsTouched && nextOrderedField.product_order_field.preset_id === `customer_${prop}`) {
      if (order.order_customer_participants.length > 0) {
        const participant = order.order_customer_participants[0]
        const participantOrderedField = participant.ordered_product_order_fields
          .find(of => of.product_order_field.preset_id === `participant_${prop}`)
        if (participantOrderedField && participantOrderedField.value === previousOrderedField.value && value !== previousOrderedField.value) {
          const nextParticipantOrderedField = {
            ...participantOrderedField,
            value,
          }

          order = updateOrderCustomerParticipant(order, {
            ...participant,
            ordered_product_order_fields: participant.ordered_product_order_fields.map(orderedField => (
              orderedField.product_order_field.id === nextParticipantOrderedField.product_order_field.id
                ? nextParticipantOrderedField
                : orderedField
            ))
          }, false)
          order = updateOrderedProductOrderField(order, parent, { product_order_field }, value)
        }
      }
    }
  })

  const nextOrderedFields = parent.ordered_product_order_fields
    .map(orderedField => (
      orderedField.product_order_field.id === product_order_field.id ? nextOrderedField : orderedField
    ))

  if (parent.model_name === "Order") {
    return {
      ...order,
      ordered_product_order_fields: nextOrderedFields
    }
  } else if (parent.model_name === "OrderedProductPricelistItem") {
    return updateOrderedProductPricelistItem(order, {
      ...parent,
      ordered_product_order_fields: nextOrderedFields
    })
  } else if (parent.model_name === "OrderCustomerParticipant") {
    return updateOrderCustomerParticipant(order, {
      ...parent,
      ordered_product_order_fields: nextOrderedFields
    })
  } else {
    throw "Unknown parent.model_name"
  }
}

export function updateOrderCustomerParticipant(order, nextParticipant, touchParticipants = true) {
  const nextParticipants = order.order_customer_participants.map(participant => {
    return (participant.position === nextParticipant.position) ? nextParticipant : participant
  })

  return {
    ...order,
    // If we're changing participant data, mark participants as touched
    _participantsCustomerFieldsTouched: order._participantsCustomerFieldsTouched || touchParticipants,
    order_customer_participants: nextParticipants,
  }
}

const serializeOrderedFieldToAttributes = orderedField => {
  let value = orderedField.value
  if (orderedField.product_order_field.type === "ProductOrderField::List") {
    value = value && { value: orderedField.value && orderedField.value.id }
  } else if (orderedField.product_order_field.type === "ProductOrderField::PickupPoint") {
    value = value && {
      pickup_point_option_id: value.pickup_point_option_id,
      custom_location_name: value.custom_location_name,
      custom_location_lat: value.custom_location_lat,
      custom_location_lng: value.custom_location_lng,
    }
  } else {
    value = value && { value }
  }
  return {
    id: orderedField.id,
    product_order_field_id: orderedField.product_order_field.id,
    value
  }
}

export const serializeOrder = order => ({
  ...order,

  ordered_product_pricelist_items_attributes: order.ordered_product_pricelist_items.map(orderedItem => {
    return {
      id: orderedItem.id,
      product_pricelist_item_id: orderedItem.product_pricelist_item.id,
      quantity: orderedItem.quantity,
      persons_count: orderedItem.persons_count,
      ordered_product_order_fields_attributes: orderedItem.ordered_product_order_fields.map(serializeOrderedFieldToAttributes)
    }
  }),
  ordered_product_pricelist_items: undefined,

  ordered_product_order_fields_attributes: order.ordered_product_order_fields.map(serializeOrderedFieldToAttributes),
  ordered_product_order_fields: undefined,

  order_customer_participants_attributes: order.order_customer_participants.map(participant => {
    return {
      ...participant,
      ordered_product_order_fields_attributes: participant.ordered_product_order_fields.map(serializeOrderedFieldToAttributes),
      ordered_product_order_fields: undefined,
    }
  }),
  order_customer_participants: undefined,

  customer_rules_agreement: !!(order.customer_rules_agreement || (order.rules_agreement && order.personal_data_agreement)),
  rules_agreement: undefined,
  personal_data_agreement: undefined,
  rodo_agreement: undefined,
  partners_agreement: undefined,
  client_ga_cookie: clientGaCookie()
})

export const clientGaCookie = () => {
  const match = document.cookie.match(new RegExp('_ga' + '=([^;]+)'));
  if (match) {
    return match[1].slice(6)
  }
}



// WEBPACK FOOTER //
// ./app/webpack/shared/utils/OrderUtils.js